import { useMemo } from 'react'
import { Link, PageProps } from 'gatsby'
import clsx from 'clsx'
import {
  Button,
  Card,
  Error,
  Search,
  Select,
  SEO,
  Space,
  Title,
} from 'components/common'
import { Booking, BookingsTable } from 'components/bookings'
import { useOrdersQuery } from 'lib/graphql/storeadmin'
import { date, datetime, time } from 'lib/str-formatter'

export const Head = () => <SEO title="下書き" />

const IndexPage = (props: PageProps<Queries.Query>): JSX.Element => {
  const { data, error, loading } = useOrdersQuery({})
  const dataSource = useMemo<Array<Booking>>(() => {
    return data?.orders?.edges?.reduce((result: Array<Booking>, { order }) => {
      const {
        id,
        approval,
        cancelReason,
        orderNumber,
        createdAt,
        customer,
        totalPrice,
        lineItems,
        bookingDates,
        period,
        numberOfPeople,
        status,
        updatedAt,
      } = order
      let bookedDate = date(bookingDates[0]?.date)
      if (bookedDate !== date(bookingDates[bookingDates?.length - 1].date)) {
        bookedDate = `${bookedDate} - ${date(
          bookingDates[bookingDates?.length - 1].date
        )}`
      }

      const orderStatus = status === 'DRAFT' ? '下書き' : '確定'

      const productNames = Array.from(
        new Set(lineItems?.edges?.map(({ lineItem }) => lineItem?.name?.jaJp))
      )

      result.push({
        key: id,
        approval,
        orderNumber,
        cancelReason: cancelReason,
        createdAt: datetime(createdAt),
        customer: `${customer?.lastName} ${customer?.firstName}`,
        total: totalPrice,
        bookingDate: bookedDate,
        bookingTime: `${time(period?.start)} - ${time(period?.end)}`,
        status: orderStatus,
        productNames: productNames,
        numberOfPeople,
        updatedAt: datetime(updatedAt),
      })
      return result
    }, [])
  }, [data])

  if (error) {
    return Error.render(error)
  }

  return (
    <>
      <div className={clsx('flex', 'justify-between', 'items-center')}>
        <div>
          <Title level={1}>下書き</Title>
        </div>
        <div className={clsx('flex', 'justify-end')}>
          <Button type="primary">
            <Link to="./new">予約を作成する</Link>
          </Button>
        </div>
      </div>

      <div>
        <Card
          tabList={[
            { key: 'all', tab: 'すべて' },
            { key: 'open-and-invoice-sent', tab: 'オープンかつ請求書送信済み' },
            { key: 'open', tab: 'オープン' },
            { key: 'invoice-sent', tab: '請求書送信済み' },
            { key: 'completed', tab: '完了' },
          ]}
          loading={loading}
          shadow
        >
          <div className={clsx('section')}>
            <Space direction="horizontal">
              <Search placeholder="下書きを絞り込む" />

              <Select defaultValue="latestUpdate" style={{ width: 200 }}>
                <Select.Option value="latestUpdate">
                  最終更新（最新順）
                </Select.Option>
              </Select>
            </Space>
          </div>

          <div className={clsx('section')}>
            <BookingsTable dataSource={dataSource} />
          </div>
        </Card>
      </div>
    </>
  )
}

export default IndexPage
